import { render } from "./cpt-input-option.vue?vue&type=template&id=70b5b685"
import script from "./cpt-input-option.vue?vue&type=script&lang=js"
export * from "./cpt-input-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__